import numeral from 'numeral';

export const squaredInchesToSquaredFeet = (value) => value * 0.00694444;

export const squaredInchesToSquaredMeters = (value) => value * 0.00064516;

export const squaredFeetToSquaredInches = (value) => value / 0.00694444;

export const squareMetersToSquareFeet = (value) => value * 10.763910416709723;

export const squareMetersToSquareInches = (value) => value * 1550;

export const squareInchesToSquareMeters = (value) => value / 1550.0;

export const metersToFeet = (value) => (value * 100) / 30.48;

export const metersToInches = (value) => (value * 100) / 2.54;

export const inchesToFeet = (value) => value / 12;

export const feetToInches = (value) => value * 12;

export const inchesToMeters = (value) => value * 0.0254;

// 23" returns 1'11"
export const inchesToFeetInches = (value, format = '0,0') => {
  let result;
  let feetinches;
  let feet;
  let inches;

  feet = Math.floor(value / 12.0);
  inches = Math.round(value - feet * 12.0);

  if (inches === 12) {
    ++feet;
    inches = 0;
  }

  feetinches = [];
  if (feet > 0) {
    feetinches.push(format ? numeral(feet).format(format) : feet);
    feetinches.push("'");
  }

  if (feet > 0) {
    if (inches > 0) {
      feetinches.push(' ');
      feetinches.push(inches);
      feetinches.push('"');
    }
  } else {
    feetinches.push(inches);
    feetinches.push('"');
  }

  return {
    feet,
    inches,
    feetinches: feetinches.join(''),
  };
};

export const metersToFeetInches = (value) => {
  let result;
  let inchesValue;

  inchesValue = metersToInches(value);
  result = inchesToFeetInches(inchesValue);

  return result;
};
